import { render } from "./TaskChangeStatusModal.vue?vue&type=template&id=600979d1"
import script from "./TaskChangeStatusModal.vue?vue&type=script&lang=js"
export * from "./TaskChangeStatusModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__